import { render } from "./IconPlayerVolumeOn.vue?vue&type=template&id=29d68a84"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__